import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  newDialog: null,
  lastChatMessage: null,
  settings: null,
  lastDialog: null,
  activeDialog: null,

  dataTelegram: [],
  activeTelegramDialog: null,

  dataWhatsapp: [],
  activeWhatsappDialog: null,

  dataInstagram: [],
  activeInstagramDialog: null,

  dataAvito: [],
  activeAvitoDialog: null,

  activeVkDialog: null,

  activeTgBotDialog: null,

  isLoadingTgBotDialog: true,
  isLoadingDialog: true,
};

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    setDialogs(state, action) {
      state.data = action.payload;
      state.isLoadingDialog = false;
    },
    setSettings(state, action) {
      state.settings = action.payload;
    },
    setLastChatMessage(state, action) {
      state.lastChatMessage = action.payload;
    },
    setNewDialog(state, action) {
      state.newDialog = action.payload;
    },
    setLastDialog(state, action) {
      state.lastDialog = action.payload;
    },
    setActiveDialog(state, action) {
      state.activeDialog = action.payload;
    },

    setActiveTelegramDialog(state, action) {
      state.activeTelegramDialog = action.payload;
    },
    setActiveWhatsappDialog(state, action) {
      state.activeWhatsappDialog = action.payload;
    },
    setActiveInstagramDialog(state, action) {
      state.activeInstagramDialog = action.payload;
    },
    setActiveAvitoDialog(state, action) {
      state.activeAvitoDialog = action.payload;
    },
    setActiveVkDialog(state, action) {
      state.activeVkDialog = action.payload;
    },

    setActiveTgBotDialog(state, action) {
      state.activeTgBotDialog = action.payload;
    },

    setIsLoadingTgBotDialog(state, action) {
      state.isLoadingTgBotDialog = action.payload;
    },

    setIsLoadingDialog(state, action) {
      state.isLoadingDialog = action.payload;
    },
    clearActiveDialogs(state, action) {
      state.activeAvitoDialog = null;
      state.activeTelegramDialog = null;
      state.activeVkDialog = null;
      state.activeWhatsappDialog = null;
      state.activeInstagramDialog = null;
    },
  },
});

export const {
  setDialogs,
  setSettings,
  setLastChatMessage,
  setNewDialog,
  setLastDialog,
  setActiveDialog,
  setActiveTelegramDialog,
  setActiveWhatsappDialog,
  setActiveInstagramDialog,
  setActiveAvitoDialog,
  setActiveVkDialog,
  setActiveTgBotDialog,
  setIsLoadingTgBotDialog,
  clearActiveDialogs,
  setIsLoadingDialog,
} = dialogSlice.actions;

export default dialogSlice.reducer;
